import { z } from 'zod'

export const userJobTitleEnum = [
   'Accountant (Associate/Senior)',
   'Accountant (Graduate/Junior/Intermediate)',
   'Administrator',
   'Assistant',
   'Bookkeeper',
   'Business Owner',
   'Client Manager',
   'Client Services Coordinator',
   'Coach / Consultant',
   'Director',
   'Management Accountant',
   'Office Manager',
   'Partner',
   'Practice Manager',
   'Principal',
   'Team Leader',
   'Other',
] as const
export const userJobTitleEnumSchema = z.enum(userJobTitleEnum, {
   errorMap: () => {
      return { message: '* Required' }
   },
})
export type UserJobTitleEnum = z.output<typeof userJobTitleEnumSchema>
